<template>
  <section class="mParty">
    <m-title-bg></m-title-bg>
    <a-spin :spinning="loading" tip="Loading..." :delay="10" style="min-height: 70px;">
    <ul class="mParty-list">
      <li class="mParty-list-item" v-for="(item, index) in newListMobile" :key="index" @click="bindNewsItem(item.id)">
        <p :class="['mParty-list-item-title', { 'has-click': item.isClick }]">{{item.title}}</p>
        <span class="mParty-list-item-date">{{item.create_time ? item.create_time.substring(0,10) : ''}}</span>
      </li>
    </ul>
    <a-button class="mParty-more" type="primary" @click="loadMore" v-if="showLoad">加载更多</a-button>
    <!-- <div class="mParty-more" type="primary" v-else style="border:none;background:none;text-align:center;line-height:10.67vw;">暂无更多</div> -->
    </a-spin>
  </section>
</template>
<script>
import MTitleBg from '../../../components/mobile/MTitleBg'
import { SchoolNews } from '../../../common/cultural/SchoolNews'
export default {
  mixins: [SchoolNews],
  components: {
    MTitleBg,
  },
  methods: {
    loadMore () {
      this.currentPage += 1;
      this.getData();
    }
  },
  computed: {
    showLoad() {
      return this.currentPage < this.totalPage;
    },
  },
}
</script>
<style lang="less" scoped>
.mParty{
  display: flex;
  flex-direction: column;
  &-list{
    display: flex;
    flex-direction: column;
    margin-top: 1vw;
    &-item{
      position: relative;
      height: 13.33vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 3.73vw;
      box-sizing: border-box;
      border-bottom: 0.13vw solid #CCCCCC;
      overflow: hidden;
      &:last-child{
        border-bottom: none;
      }
      &::after{
        position: absolute;
        content: '';
        left: 0;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        height: 0.8vw;
        width: 0.8vw;
        background: #C16613;
        border-radius: 100%;
      }
      &-title{
        flex-grow: 1;
        height: 13.33vw;
        line-height: 13.33vw;
        font-size:3.73vw;
        font-weight:400;
        color:rgba(0,0,0,1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.has-click{
          color: #666;
        }
      }
      &-date{
        flex-shrink: 0;
        margin-left: 2.67vw;
        width: 22vw;
        text-align: center;
        font-size:3.73vw;
        font-weight:300;
        color:#999;
      }
    }
  }
  &-more{
    margin: 4.67vw 0 6.67vw;
    width: 100%;
    height:10.67vw;
    font-size:3.47vw;
    font-weight:300;
    color:rgba(102,102,102,1);
    background:rgba(241,241,241,1);
    border:0.13vw solid rgba(204,204,204,1);
    border-radius:1.33vw;
  }
}
</style>
